import {types} from './types';

const setGetAmountReferralsAction = (payload) => {
    return {
        type: types.SET_AMOUNT,
        payload,
      }
}

const setGetReferralsAction = (payload) => {
  return {
    type: types.SET_REFERRALS,
    payload,
  }
}

const setGetViewReferralAction = (payload) => {
  return {
    type: types.SET_REFERRAL_INFO,
    payload,
  }
}

export {
  setGetAmountReferralsAction,
  setGetReferralsAction,
  setGetViewReferralAction
}